import React, { Component } from "react";
import { Drawer, message, Select } from "antd";
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { map, orderBy, isEmpty } from "lodash";
import plus_icon from '../../../../../Assets/images/plus_icon.svg';
import cross_icon from '../../../../../Assets/images/cross_icon.svg';
import * as yup from "yup";
import Loader from "../../../../Common/Component/Loader";
import Script from "react-load-script";
import AllState from "../../../../../Assets/data/stateList.json";
import Axios from 'axios';
const { Option } = Select;

const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class UpdateContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      communityInfo: {
        uuid: '',
        first_name: '',
        last_name: '',
        phone_numbers: [{phone: "", type: "home_phone", can_send_sms: false, primary: true}],
        emails: [],
        removed_emails: [],
        email: '',
        on_site: false,
        notes: '',
        permissions: [{
          name: 'proposal_ready',
          type_display: 'Proposal ready',
          email: false,
          text: false
        }, {
          name: 'proposal_signed',
          type_display: 'Proposal signed',
          email: false,
          text: false
        }, {
          name: 'installation_scheduled',
          type_display: 'Installation scheduled',
          email: false,
          text: false
        }, {
          name: 'installation_complete',
          type_display: 'Installation complete',
          email: false,
          text: false
        }, {
          name: 'service_complete',
          type_display: 'Service complete',
          email: false,
          text: false
        }, {
          name: 'service_issues',
          type_display: 'Service issue',
          email: false,
          text: false
        }, {
          name: 'billing_notifications',
          type_display: 'Billing notification',
          email: false,
          text: false
        }]
      },
      billingInfo: {
        uuid: '',
        name: '',
        phone_numbers: [{phone: "", type: "home_phone", can_send_sms: false, primary: true}],
        emails: [],
        removed_emails: [],
        email: '',
        permissions: [{
          name: 'proposal_ready',
          type_display: 'Proposal ready',
          email: false,
          text: false
        }, {
          name: 'proposal_signed',
          type_display: 'Proposal signed',
          email: false,
          text: false
        }, {
          name: 'installation_scheduled',
          type_display: 'Installation scheduled',
          email: false,
          text: false
        }, {
          name: 'installation_complete',
          type_display: 'Installation complete',
          email: false,
          text: false
        }, {
          name: 'service_complete',
          type_display: 'Service complete',
          email: false,
          text: false
        }, {
          name: 'service_issues',
          type_display: 'Service issue',
          email: false,
          text: false
        }, {
          name: 'billing_notifications',
          type_display: 'Billing notification',
          email: false,
          text: false
        }]
      },
      companyInfo: {
        uuid: '',
        name: '',
        phone_numbers: [{phone: "", type: "home_phone", can_send_sms: false, primary: true}],
        emails: [],
        removed_emails: [],
        email: '',
        pointOfContact: '',
        permissions: [{
          name: 'proposal_ready',
          type_display: 'Proposal ready',
          email: false,
          text: false
        }, {
          name: 'proposal_signed',
          type_display: 'Proposal signed',
          email: false,
          text: false
        }, {
          name: 'installation_scheduled',
          type_display: 'Installation scheduled',
          email: false,
          text: false
        }, {
          name: 'installation_complete',
          type_display: 'Installation complete',
          email: false,
          text: false
        }, {
          name: 'service_complete',
          type_display: 'Service complete',
          email: false,
          text: false
        }, {
          name: 'service_issues',
          type_display: 'Service issue',
          email: false,
          text: false
        }, {
          name: 'billing_notifications',
          type_display: 'Billing notification',
          email: false,
          text: false
        }]
      },
      uuid: '',
      is_btn_active: true,
      customer: {},
      address: {},
      is_print_and_mail_invoices: false,
      is_email_invoice: false,
      community_name: ""
    }
  }

  componentDidMount() {
    const {customerId, getCommercialCustomer} = this.props;
    if (customerId) {
      getCommercialCustomer(customerId) // get customer detail
    }

    //set customer details
    if (Object.keys(this.props?.CommercialCustomer?.getCustomer).length > 0) {
      this.setState({
        address: this.props?.CommercialCustomer?.getCustomer?.invoice_address ? this.props?.CommercialCustomer?.getCustomer?.invoice_address : '',
        is_print_and_mail_invoices: this.props?.CommercialCustomer?.getCustomer?.invoice_address ? this.props?.CommercialCustomer?.getCustomer?.is_print_and_mail_invoices : this.state.is_print_and_mail_invoices,
        is_email_invoice: this.props?.CommercialCustomer?.getCustomer?.invoice_address ? this.props?.CommercialCustomer?.getCustomer?.is_email_invoice : this.state.is_email_invoice,
      });
    }

    setTimeout(() => {
    // set invoice address if is_print_and_mail_invoices is true
      if (Object.keys(this.props?.CommercialCustomer?.getCustomer).length > 0 && this.props?.CommercialCustomer?.getCustomer?.is_print_and_mail_invoices) {
        if (this.refs["address"]) {
          let addressStr = this.props?.CommercialCustomer?.getCustomer?.invoice_address?.address ? `${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.address}` : '';
          addressStr += this.props?.CommercialCustomer?.getCustomer?.invoice_address?.city ? `, ${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.city}` : '';
          addressStr += this.props?.CommercialCustomer?.getCustomer?.invoice_address?.state ? `, ${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.state}` : '';
          addressStr += this.props?.CommercialCustomer?.getCustomer?.invoice_address?.zip_code ? `, ${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.zip_code}` : '';
          this.refs["address"].value = addressStr;
        }
        const address = {
          address: this.props?.CommercialCustomer?.getCustomer?.invoice_address?.address ? `${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.address}` : '',
          city: this.props?.CommercialCustomer?.getCustomer?.invoice_address?.city ? `${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.city}` : '',
          state: this.props?.CommercialCustomer?.getCustomer?.invoice_address?.state ? `${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.state}` : '',
          zip_code: this.props?.CommercialCustomer?.getCustomer?.invoice_address?.zip_code ? `${this.props?.CommercialCustomer?.getCustomer?.invoice_address?.zip_code}` : '',
        }
        this.setState({
          address: address
        });
      }
    }, 100);
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    const {communityInfo} = this.state;
    this.setState({loader: false});

    // get customer info
    if (Object.keys(nextProps?.CommercialCustomer?.getCustomer).length > 0
      && JSON.stringify(nextProps?.CommercialCustomer?.getCustomer) !== JSON.stringify(this.state.customer)) 
      {
      this.setState({
        uuid: nextProps?.CommercialCustomer?.getCustomer?.uuid,
        customer: nextProps?.CommercialCustomer?.getCustomer,
        community_name: nextProps?.CommercialCustomer?.getCustomer?.community_name
      },
        () => {
        this.props.getNotificationById({user__uuid: this.props.customerId})
        this.setData(nextProps?.CommercialCustomer?.getCustomer?.guest_users || []);
      });
    }

    // get customer info
    if (Object.keys(nextProps?.NotificationList?.data).length > 0
      && JSON.stringify(nextProps?.NotificationList?.data?.results) !== JSON.stringify(communityInfo?.permissions)) {
      
      const permissions = nextProps?.NotificationList?.data?.results || [];
      let obj = {
        ...communityInfo,
        permissions: [{
          uuid: permissions?.find((obj) => obj.type === 'proposal_ready')?.uuid,
          name: 'proposal_ready',
          type_display: 'Proposal ready',
          email: permissions?.find((obj) => obj.type === 'proposal_ready')?.email || false,
          text: permissions?.find((obj) => obj.type === 'proposal_ready')?.text || false
        },
        {
          uuid: permissions?.find((obj) => obj.type === 'proposal_signed')?.uuid,
          name: 'proposal_signed',
          type_display: 'Proposal signed',
          email: permissions?.find((obj) => obj.type === 'proposal_signed')?.email || false,
          text: permissions?.find((obj) => obj.type === 'proposal_signed')?.text || false
        }, {
          uuid: permissions?.find((obj) => obj.type === 'installation_scheduled')?.uuid,
          name: 'installation_scheduled',
          type_display: 'Installation scheduled',
          email: permissions?.find((obj) => obj.type === 'installation_scheduled')?.email || false,
          text: permissions?.find((obj) => obj.type === 'installation_scheduled')?.text || false
        }, {
          uuid: permissions?.find((obj) => obj.type === 'installation_complete')?.uuid,
          name: 'installation_complete',
          type_display: 'Installation complete',
          email: permissions?.find((obj) => obj.type === 'installation_complete')?.email || false,
          text: permissions?.find((obj) => obj.type === 'installation_complete')?.text || false
        }, {
          uuid: permissions?.find((obj) => obj.type === 'service_complete')?.uuid,
          name: 'service_complete',
          type_display: 'Service complete',
          email: permissions?.find((obj) => obj.type === 'service_complete')?.email || false,
          text: permissions?.find((obj) => obj.type === 'service_complete')?.text || false
        }, {
          uuid: permissions?.find((obj) => obj.type === 'service_issues')?.uuid,
          name: 'service_issues',
          type_display: 'Service issue',
          email: permissions?.find((obj) => obj.type === 'service_issues')?.email || false,
          text: permissions?.find((obj) => obj.type === 'service_issues')?.text || false
        }, {
          uuid: permissions?.find((obj) => obj.type === 'billing_notifications')?.uuid,
          name: 'billing_notifications',
          type_display: 'Billing notification',
          email: permissions?.find((obj) => obj.type === 'billing_notifications')?.email || false,
          text: permissions?.find((obj) => obj.type === 'billing_notifications')?.text || false
        }]
      }
      this.setState({communityInfo: obj});
    }

    // get geocode
    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && 
      JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      
        this.setAddress(nextProps?.GoogleApi?.getGeocode);
    }
  }

  // set address
  setAddress = (addressObject) => {
    
    if (!isEmpty(addressObject)) 
    {
      if (addressObject?.status === "OK") 
      {
        let obj = {}, components = addressObject?.results?.[0];
        
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({address: obj}, () => {
          if (!obj?.address || !obj?.state || !obj.city) {
            message.error('Please enter valid address');
          }
        })
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address});
  };
  
  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  // Google Map Place API
  handleScriptLoad = () => {
    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address', 'geometry']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }

  // on start place change
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      // location = { lat: addressObject.geometry.location.lat(), lng: addressObject.geometry.location.lng() }
      });
      obj.address= `${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({address: obj}, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address');
        }
      })
    }).catch((err) => {
      console.log(err)
    });

    // this.setState({address: obj}, () => {
    // const address_obj = (obj?.street_number || obj?.route) ? {...obj, address: `${obj?.street_number || ''} ${obj?.route || ''}`} : obj;
    // const address = `${address_obj.address} ${address_obj.city} ${address_obj.state} ${address_obj.zip_code}`;
    // this.props.resetGeocodeAddress()
    // this.props.getGeocodeAddress({key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY, address})
  }

  // on print invoice change
  onPrintInvoiceChange = (e) => {
    const { invoice_address } = this.props.customer;
    const address = {
      address: invoice_address?.address ? `${invoice_address?.address}` : '',
      city: invoice_address?.city ? `${invoice_address?.city}` : '',
      state: invoice_address?.state ? `${invoice_address?.state}` : '',
      zip_code: invoice_address?.zip_code ? `${invoice_address?.zip_code}` : '',
    }
    if (e.target.checked) {
      setTimeout( () => {
        if (this.refs["address"]) {
          let addressStr = invoice_address?.address ? `${invoice_address?.address}` : '';
          addressStr += invoice_address?.city ? `, ${invoice_address?.city}` : '';
          addressStr += invoice_address?.state ? `, ${invoice_address?.state}` : '';
          addressStr += invoice_address?.zip_code ? `, ${invoice_address?.zip_code}` : '';
          this.refs["address"].value = addressStr;
        }
      });
      this.setState({
        is_print_and_mail_invoices: e.target.checked,
        address: address
      });
    } else {
      this.refs["address"].value = null;
      this.setState({
        is_print_and_mail_invoices: e.target.checked,
        address: address
      });
    }
  }

  // on email invoice change
  onEmailInvoiceChange = (e) => {
    if (e.target.checked) {
      this.setState({
        is_email_invoice: e.target.checked,
      })
    } else {
      this.setState({
        is_email_invoice: e.target.checked,
      })
    }
  }

  // set data
  setData = (guest_users) => {
    const {
      customer,
      communityInfo,
    } = this.state;

    const community_manager = {
      first_name: `${customer?.first_name || ''}`,
      last_name: `${customer?.last_name || ''}`,
      phone_number: customer?.phone_numbers,
      uuid: customer.uuid,
      email: customer?.email || [],
      emails: customer?.emailaddress_set || [],
    };

    const billing = guest_users?.filter(obj => obj.role === 'billing')[0] || {};
    const management = guest_users?.filter(obj => obj.role === 'management')[0] || {};
    let community_emails = [];

    if(community_manager.emails.length > 0)
    {
      community_emails = community_manager.emails;
    }
    else if(community_manager.email != '')
    {
      community_emails.push({email: community_manager.email, primary: true});
    }

    const community_obj = {
      uuid: community_manager?.uuid,
      first_name: community_manager?.first_name,
      last_name: community_manager?.last_name,
      phone_numbers: community_manager?.phone_number || [],
      emails: community_emails,
      email: '',
      removed_emails:[],
      on_site: false,
      notes: community_manager?.notes ? community_manager?.notes : '',
    };

    const billing_obj = {
      name: billing?.user_name,
      phone_numbers: [{phone: billing?.phone_number, type: "home_phone", can_send_sms: false, primary: true}],
      emails: guest_users?.filter(obj => obj.role === 'billing'  && obj.email) || [],
      email: '',
      removed_emails:[],
      permissions: [{
        name: 'proposal_ready',
        type_display: 'Proposal ready',
        email: billing?.permissions?.find((obj) => obj.name === 'proposal_ready')?.email || false,
        text: billing?.permissions?.find((obj) => obj.name === 'proposal_ready')?.text || false
      }, {
        name: 'proposal_signed',
        type_display: 'Proposal signed',
        email: billing?.permissions?.find((obj) => obj.name === 'proposal_signed')?.email || false,
        text: billing?.permissions?.find((obj) => obj.name === 'proposal_signed')?.text || false
      }, {
        name: 'installation_scheduled',
        type_display: 'Installation scheduled',
        email: billing?.permissions?.find((obj) => obj.name === 'installation_scheduled')?.email || false,
        text: billing?.permissions?.find((obj) => obj.name === 'installation_scheduled')?.text || false
      }, {
        name: 'installation_complete',
        type_display: 'Installation complete',
        email: billing?.permissions?.find((obj) => obj.name === 'installation_complete')?.email || false,
        text: billing?.permissions?.find((obj) => obj.name === 'installation_complete')?.text || false
      }, {
        name: 'service_complete',
        type_display: 'Service complete',
        email: billing?.permissions?.find((obj) => obj.name === 'service_complete')?.email || false,
        text: billing?.permissions?.find((obj) => obj.name === 'service_complete')?.text || false
      }, {
        name: 'service_issues',
        type_display: 'Service issue',
        email: billing?.permissions?.find((obj) => obj.name === 'service_issues')?.email || false,
        text: billing?.permissions?.find((obj) => obj.name === 'service_issues')?.text || false
      }, {
        name: 'billing_notifications',
        type_display: 'Billing notification',
        email: billing?.permissions?.find((obj) => obj.name === 'billing_notifications')?.email || false,
        text: billing?.permissions?.find((obj) => obj.name === 'billing_notifications')?.text || false
      }]
    };

    const management_obj = {
      name: management?.user_name,
      phone_numbers: [{phone: management?.phone_number, type: "home_phone", can_send_sms: false, primary: true}],
      emails: guest_users?.filter(obj => obj.role === 'management' && obj.email) || [],
      email: '',
      removed_emails:[],
      pointOfContact: management?.point_of_contact ? management?.point_of_contact : '',
      permissions:[{
        name: 'proposal_ready',
        type_display: 'Proposal ready',
        email: management?.permissions?.find((obj) => obj.name === 'proposal_ready')?.email || false,
        text: management?.permissions?.find((obj) => obj.name === 'proposal_ready')?.text || false
      }, {
        name: 'proposal_signed',
        type_display: 'Proposal signed',
        email: management?.permissions?.find((obj) => obj.name === 'proposal_signed')?.email || false,
        text: management?.permissions?.find((obj) => obj.name === 'proposal_signed')?.text || false
      }, {
        name: 'installation_scheduled',
        type_display: 'Installation scheduled',
        email: management?.permissions?.find((obj) => obj.name === 'installation_scheduled')?.email || false,
        text: management?.permissions?.find((obj) => obj.name === 'installation_scheduled')?.text || false
      }, {
        name: 'installation_complete',
        type_display: 'Installation complete',
        email: management?.permissions?.find((obj) => obj.name === 'installation_complete')?.email || false,
        text: management?.permissions?.find((obj) => obj.name === 'installation_complete')?.text || false
      }, {
        name: 'service_complete',
        type_display: 'Service complete',
        email: management?.permissions?.find((obj) => obj.name === 'service_complete')?.email || false,
        text: management?.permissions?.find((obj) => obj.name === 'service_complete')?.text || false
      }, {
        name: 'service_issues',
        type_display: 'Service issue',
        email: management?.permissions?.find((obj) => obj.name === 'service_issues')?.email || false,
        text: management?.permissions?.find((obj) => obj.name === 'service_issues')?.text || false
      }, {
        name: 'billing_notifications',
        type_display: 'Billing notification',
        email: management?.permissions?.find((obj) => obj.name === 'billing_notifications')?.email || false,
        text: management?.permissions?.find((obj) => obj.name === 'billing_notifications')?.text || false
      }]
    };

    this.setState({communityInfo: community_obj, billingInfo: billing_obj, companyInfo: management_obj})
  }

  // Format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  onClear = () => {
    this.setState({
      communityInfo: {
        uuid: '',
        phone_numbers: [{phone: "", type: "home_phone", can_send_sms: false, primary: true}],
        emails: [],
        email: '',
        on_site: false,
        notes: '',
        permissions: [{
          name: 'proposal_ready',
          type_display: 'Proposal ready',
          email: false,
          text: false
        }, {
          name: 'proposal_signed',
          type_display: 'Proposal signed',
          email: false,
          text: false
        }, {
          name: 'installation_scheduled',
          type_display: 'Installation scheduled',
          email: false,
          text: false
        }, {
          name: 'installation_complete',
          type_display: 'Installation complete',
          email: false,
          text: false
        }, {
          name: 'service_complete',
          type_display: 'Service complete',
          email: false,
          text: false
        }, {
          name: 'service_issues',
          type_display: 'Service issue',
          email: false,
          text: false
        }, {
          name: 'billing_notifications',
          type_display: 'Billing notification',
          email: false,
          text: false
        }]
      },
      billingInfo: {
        uuid: '',
        phone_numbers: [{phone: "", type: "home_phone", can_send_sms: false, primary: true}],
        emails: [],
        email: '',
        permissions: [{
          name: 'proposal_ready',
          type_display: 'Proposal ready',
          email: false,
          text: false
        }, {
          name: 'proposal_signed',
          type_display: 'Proposal signed',
          email: false,
          text: false
        }, {
          name: 'installation_scheduled',
          type_display: 'Installation scheduled',
          email: false,
          text: false
        }, {
          name: 'installation_complete',
          type_display: 'Installation complete',
          email: false,
          text: false
        }, {
          name: 'service_complete',
          type_display: 'Service complete',
          email: false,
          text: false
        }, {
          name: 'service_issues',
          type_display: 'Service issue',
          email: false,
          text: false
        }, {
          name: 'billing_notifications',
          type_display: 'Billing notification',
          email: false,
          text: false
        }]
      },
      companyInfo: {
        uuid: '',
        phone_numbers: [{phone: "", type: "home_phone", can_send_sms: false, primary: true}],
        emails: [],
        email: '',
        pointOfContact: '',
        permissions: [{
          name: 'proposal_ready',
          type_display: 'Proposal ready',
          email: false,
          text: false
        }, {
          name: 'proposal_signed',
          type_display: 'Proposal signed',
          email: false,
          text: false
        }, {
          name: 'installation_scheduled',
          type_display: 'Installation scheduled',
          email: false,
          text: false
        }, {
          name: 'installation_complete',
          type_display: 'Installation complete',
          email: false,
          text: false
        }, {
          name: 'service_complete',
          type_display: 'Service complete',
          email: false,
          text: false
        }, {
          name: 'service_issues',
          type_display: 'Service issue',
          email: false,
          text: false
        }, {
          name: 'billing_notifications',
          type_display: 'Billing notification',
          email: false,
          text: false
        }]
      },
      uuid: '',
      address: {}
    }, () => this.validate())
  }

  // On update
  onUpdateClick = () => {
    const { address, is_print_and_mail_invoices } = this.state;

    if (is_print_and_mail_invoices) {
      const schema = yup.object().shape({
        address: yup.object().shape({
          address: yup.string().required('address is required.'),
          city: yup.string().required('city is required.'),
          state: yup.string().required('state is required.'),
          zip_code: yup.string().required('zip code is required.')
        }),
      });

      const data = { address };
      schema.validate(data, {abortEarly: false}).then(() => {
        this.setState({errors: {}});
        this.updateCustomerDetails();
      }).catch(() => {
        this.setState({errors: {}});
        message.error('Please enter valid invoice address')
      })
    } else {
      this.updateCustomerDetails();
    }
  };

  updateCustomerDetails = () => {
    const {
      customerId,
      closeDrawer,
      getCommercialCustomer,
      updateCommercialCustomer,
    } = this.props;
    const {
      uuid,
      address,
      billingInfo,
      companyInfo,
      communityInfo,
      community_name,
      is_email_invoice,
      is_print_and_mail_invoices,
    } = this.state;

    this.setState({loader: true});

    let arr = [], community_per = [], billing_per = [], company_per = [], community_permission = [];
    map(communityInfo?.permissions, x => {if (x.email || x.text) community_per.push(x)});
    const isCommunityInfo = communityInfo?.emails?.[0]?.email || communityInfo?.notes 
      || communityInfo?.phone_numbers?.[0]?.phone || !isEmpty(community_per) || [];
    map(billingInfo?.permissions, x => {if (x.email || x.text) billing_per.push(x)});
    const isBillingInfo = billingInfo?.emails || billingInfo?.phone_numbers?.[0]?.phone 
      || billingInfo?.name || !isEmpty(billing_per) || [];
    map(companyInfo?.permissions, x => {if (x.email || x.text) company_per.push(x)});
    const isCompanyInfo = companyInfo?.emails?.[0]?.email || companyInfo?.pointOfContact 
      || companyInfo?.phone_numbers?.[0]?.phone || companyInfo?.name || !isEmpty(company_per) || [];

    let primary;
    let guest_users = [];
    let permissions = [];
    let billing_needs_primary = !billingInfo?.emails.find(item => item.primary);
    let company_needs_primary = !companyInfo?.emails.find(item => item.primary);

    //Code if billingInfo email is not entered
    permissions = map(billingInfo?.permissions, permission => {
      return {
        name: permission.name,
        email: permission.email,
        text: permission.text
    }});

    if (billingInfo?.emails && !billingInfo?.emails.length) {
      primary =false;
      guest_users.push({
        primary,
        permissions, 
        email: billingInfo?.email ? billingInfo?.email :null,
        role: 'billing',
        user_uuid: uuid,
        notes: null, 
        point_of_contact: null,
        user_name: billingInfo?.name,
        uuid: "",
        phone_number: billingInfo?.phone_numbers?.[0]?.phone,
      });
    }
    map(billingInfo?.emails, (item, index) => {
      if(index < 0)
        return
       
      primary = billing_needs_primary ? true : item.primary;
      primary = item.email ? primary : false;
      guest_users.push({
        primary,
        permissions, 
        email: item.email, 
        role: 'billing',
        user_uuid: uuid,
        notes: null, 
        point_of_contact: null,
        user_name: billingInfo?.name,
        uuid: item?.uuid ? item?.uuid : "",
        phone_number: billingInfo?.phone_numbers?.[0]?.phone,
      });
    });

     //Code if companyInfo email is not entered
     permissions = map(companyInfo?.permissions, permission => {
      return {
        name: permission.name,
        email: permission.email,
        text: permission.text
      }});
      if (companyInfo?.emails && !companyInfo?.emails.length) {
      primary =false;
      guest_users.push({
        primary,
        permissions,
        user_uuid: uuid,
        email: companyInfo?.email ? companyInfo?.email :null,
        role: 'management',
        notes: null, 
        point_of_contact: null,
        user_name: companyInfo?.name,
        uuid: "",
        phone_number: companyInfo?.phone_numbers?.[0]?.phone,
      });
    }
    map(companyInfo?.emails, (item, index) => {
      if(index < 0)
        return

      primary = company_needs_primary ? true : item.primary;
      primary = item.email ? primary : false;
      guest_users.push({
        primary,
        permissions,
        user_uuid: uuid,
        email: item.email,
        role: 'management',
        notes: null, 
        point_of_contact: null,
        user_name: companyInfo?.name,
        uuid: item?.uuid ? item?.uuid : "",
        phone_number: companyInfo?.phone_numbers?.[0]?.phone,
      }); 
    });
    
    const email = communityInfo?.emails?.find(x => x.primary === true)?.email
      || communityInfo?.emails?.[0]?.email || [];
    const first_name = communityInfo?.first_name ? communityInfo?.first_name : '';
    const last_name = communityInfo?.last_name ? communityInfo?.last_name : '';
    
    arr.push(updateCommercialCustomer(uuid, 
      {
        first_name,
        last_name,
        email,
        emailaddress_set: communityInfo?.emails,
        emailaddress_set_deleted: communityInfo.removed_emails,
        guest_users_set_deleted: [...billingInfo.removed_emails, ...companyInfo.removed_emails],
        guest_users_set: guest_users,
        phone_numbers: communityInfo?.phone_numbers,
        invoice_address: address,
        is_print_and_mail_invoices: is_print_and_mail_invoices, 
        is_email_invoice: is_email_invoice,
        community_name: community_name
      }))

    map(communityInfo?.permissions, x => {
      community_permission.push({uuid: x.uuid, email: x?.email, text: x?.text})
    });

    this.props.updateNotificationById(community_permission);

    Promise.all(arr).then((response) => {
      if(response.length) {
        closeDrawer();
        getCommercialCustomer(customerId) // get customer detail
        this.onClear();
      }else{
        closeDrawer();
      }
    });
  }

  //on cancel
  onCancel = () => {
    this.onClear();
    this.props.closeDrawer();
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    // console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on community manager info changed
  onCommunityInfoChanged = (e, type, index, permissionType) => {
    const {communityInfo} = this.state;

    if (type === 'phone_numbers') {
      Object.assign(communityInfo.phone_numbers[index], {[e.target.name]: e.target.value})
      if (index === 0) {
        Object.assign(communityInfo.phone_numbers[index], {primary: true})
      }
      if (e.target.name === 'type' && e.target.value === 'home_phone') {
        Object.assign(communityInfo.phone_numbers[index], {'can_send_sms': false})
      }
      this.setState({communityInfo}, () => this.validate());

    } else if (type === 'emails') {
      if(communityInfo?.emails?.length === 0)
      {
        communityInfo.emails.push({email: communityInfo?.email, primary: true});
      }
      else
      {
        communityInfo.emails.push({email: communityInfo?.email, primary: false});
      }
      
      Object.assign(communityInfo, {email: ''})
      this.setState({communityInfo}, () => this.validate());

    } else if (type === 'add_more') {
      let temp_phone = {phone: "", type: "home_phone", can_send_sms: false}
      communityInfo.phone_numbers.push(temp_phone);
      this.setState({ communityInfo }, () => this.validate())

    } else if (type === 'remove_phone') {
      communityInfo.phone_numbers.splice(index, 1);
      this.setState({ communityInfo }, () => this.validate())

    } else if (type === 'remove_email') {
      const index_id = communityInfo.emails.findIndex(obj => obj.email === index.email);
      const removed = communityInfo.emails[index_id];

      communityInfo.emails.splice(index_id, 1);

      if(removed?.uuid)
      {
        communityInfo.removed_emails.push(removed.uuid);
        console.log(communityInfo.removed_emails);
      }
      this.setState({ communityInfo }, () => this.validate())

    } else if (type === 'permission') {
      const idx = communityInfo?.permissions?.findIndex(obj => obj.name === permissionType);
      if (idx > -1) {
        communityInfo.permissions[idx] = Object.assign(communityInfo?.permissions?.[idx], { [e.target.name]: e.target.checked });
        this.setState({ communityInfo }, () => this.validate());
      }
    } else {
      const value = type === 'bool' ? e.target.checked : e.target.value;

      Object.assign(communityInfo, {[e.target.name]: value});
      this.setState({communityInfo}, () => this.validate());
    }
  }

  // on community manager info changed
  onBillingInfoChanged = (e, type, index, permissionType, email) => {
    let { billingInfo } = {...this.state};

    if (type === 'phone_numbers') {
      Object.assign(billingInfo.phone_numbers[index], {[e.target.name]: e.target.value})
      if (index === 0) {
        Object.assign(billingInfo.phone_numbers[index], {primary: true})
      }
      if (e.target.name === 'type' && e.target.value === 'home_phone') {
        Object.assign(billingInfo.phone_numbers[index], {'can_send_sms': false})
      }
      this.setState({billingInfo}, () => this.validate());

    } else if (type === 'emails') {
      if(billingInfo?.emails?.length === 0)
      {
        billingInfo?.emails?.push({email: billingInfo?.email, primary: true});
      }
      else
      {
        billingInfo.emails.push({email: billingInfo?.email, primary: false});
      }
      
      Object.assign(billingInfo, {email: ''})
      this.setState({billingInfo}, () => this.validate());

    } else if (type === 'add_more') {
      let temp_phone = {phone: "", type: "home_phone", can_send_sms: false}
      billingInfo.phone_numbers.push(temp_phone);
      this.setState({ billingInfo }, () => this.validate())

    } else if (type === 'remove_phone') {
      billingInfo.phone_numbers.splice(index, 1);
      this.setState({ billingInfo }, () => this.validate())

    } else if (type === 'remove_email') {
      let i = billingInfo.emails.findIndex(item => item.email === email);
      const removed = billingInfo.emails[i];

      billingInfo.emails.splice(i, 1);

      if(removed?.uuid)
      {
        billingInfo.removed_emails.push(removed.uuid);
      }
      
      this.setState({billingInfo }, () => this.validate());
    } else if (type === 'permission') {
      const idx = billingInfo?.permissions?.findIndex(obj => obj.name === permissionType);
      if (idx > -1) {
        billingInfo.permissions[idx] = Object.assign(billingInfo?.permissions?.[idx], { [e.target.name]: e.target.checked });
        this.setState({ billingInfo }, () => this.validate());
      }
    } else if (type === 'billing_name') {
      Object.assign(billingInfo, {name: e.target.value});
      this.setState({ billingInfo });
    } else {
      const value = type === 'bool' ? e.target.checked : e.target.value;
      Object.assign(billingInfo, {[e.target.name]: value});
      this.setState({billingInfo}, () => this.validate());
    }
  }

  // on company info changed
  onCompanyInfoChanged = (e, type, index, permissionType, email) => {
    const {companyInfo} = {...this.state};

    if (type === 'phone_numbers') {
      Object.assign(companyInfo.phone_numbers[index], {[e.target.name]: e.target.value})
      if (index === 0) {
        Object.assign(companyInfo.phone_numbers[index], {primary: true})
      }
      if (e.target.name === 'type' && e.target.value === 'home_phone') {
        Object.assign(companyInfo.phone_numbers[index], {'can_send_sms': false})
      }
      this.setState({companyInfo}, () => this.validate());

    } else if (type === 'emails') {
      if(companyInfo.emails.length === 0)
      {
        companyInfo.emails.push({email: companyInfo?.email, primary: true});
      }
      else
      {
        companyInfo.emails.push({email: companyInfo?.email, primary: false});
      }
      
      Object.assign(companyInfo, {email: ''})
      this.setState({companyInfo}, () => this.validate());

    } else if (type === 'add_more') {
      let temp_phone = {phone: "", type: "home_phone", can_send_sms: false}
      companyInfo.phone_numbers.push(temp_phone);
      this.setState({ companyInfo }, () => this.validate())

    } else if (type === 'remove_phone') {
      companyInfo.phone_numbers.splice(index, 1);
      this.setState({ companyInfo }, () => this.validate())

    } else if (type === 'remove_email') {
      const i = companyInfo.emails.findIndex(item => item.email === email);
      const removed = companyInfo.emails[i];
      companyInfo.emails.splice(i, 1);

      if(removed?.uuid)
      {
        companyInfo.removed_emails.push(removed.uuid);
      }

      this.setState({ companyInfo }, () => this.validate())

    } else if (type === 'permission') {
      const idx = companyInfo?.permissions?.findIndex(obj => obj.name === permissionType);
      if (idx > -1) {
        companyInfo.permissions[idx] = Object.assign(companyInfo?.permissions?.[idx], { [e.target.name]: e.target.checked });
        this.setState({ companyInfo }, () => this.validate());
      }
    } else if (type === 'company_name') {
      Object.assign(companyInfo, {name: e.target.value});
      this.setState({ companyInfo });
    }else {
      const value = type === 'bool' ? e.target.checked : e.target.value;
      Object.assign(companyInfo, {[e.target.name]: value})
      this.setState({companyInfo}, () => this.validate());
    }
  }

  // validate required fields
  validate = () => {
    const { communityInfo, billingInfo, companyInfo } = this.state;
    const schema = yup.object().shape({
      communityInfo: yup.object().shape({
        // name: yup.string().required('Community Manager is required'),
        // phone_numbers: yup.array(yup.object({
        //   phone: yup.string().required('Community phone is required'),
        //   type: yup.string().required('Community phone type is required'),
        // })),
        // emails: yup.array(yup.object({
        //   email: yup.string().required('Community email is required')
        // })).required("Email Addresses are required"),
      }),
      billingInfo: yup.object().shape({
        // name: yup.string().required('Billing name is required'),
        // phone_numbers: yup.array(yup.object({
        //   phone: yup.string().required('Billing phone is required'),
        //   type: yup.string().required('Billing phone Type is required'),
        // })),
        // emails: yup.array(yup.object({
        //   email: yup.string().required('Billing email is required')
        // })).required("Email Addresses are required"),
      }),
      companyInfo: yup.object().shape({
        // name: yup.string().required('Company name is required'),
        // phone_numbers: yup.array(yup.object({
        //   phone: yup.string().required('Company phone is required'),
        //   type: yup.string().required('Company phone Type is required'),
        // })),
        // emails: yup.array(yup.object({
        //   email: yup.string().required('Company email is required')
        // })).required("Email Addresses are required"),
      })
    });

    const data = { communityInfo, billingInfo, companyInfo }

    setTimeout(() => {
      schema.validate(data, {abortEarly: false}).then(() => {
        this.setState({is_btn_active: true, errors: {}});
      }).catch(() => {
        message.error('Community phone is required')
        this.setState({is_btn_active: false, errors: {}})
      })
    }, 500);
  }

  renderCommunityManagerInfo = () => {
    const {communityInfo, community_name} = this.state;

    return (
      <div className="flex-1">
        <div className={"flex"}>
          <label>First Name</label>
          <div className="half-fitem fitem">
            <input
              type="text"
              name="first_name"
              value={communityInfo?.first_name}
              onChange={(e) => this.onCommunityInfoChanged(e)}
              className="form--control"
              placeholder="Firstname"
            />
          </div>
          <div className="half-fitem fitem">
            <label>Last Name</label>
            <input
              type="text"
              name="last_name"
              value={communityInfo?.last_name}
              onChange={(e) => this.onCommunityInfoChanged(e)}
              className="form--control"
              placeholder="Lastname"
            />
          </div>
        </div>
        <div className={"flex"}>
          <label>Community Name</label>
          <div className="half-fitem fitem">
            <input
              type="text"
              name="community_name"
              value={community_name}
              onChange={(e) => {
                this.setState({
                  community_name: e?.target?.value
                })
              }}
              className="form--control"
              placeholder="Community name"
            />
          </div>
        </div>
        <div className="fitem-check">
          <input
            type="checkbox"
            className="fitem-ck-input"
            id={`onsite`}
            name={`onsite`}
            checked={communityInfo?.on_site}
            onChange={(e) => this.onCommunityInfoChanged({target: {name: 'on_site', value: e.target.checked}})}
          />
          <label htmlFor={`onsite`} className="fitem-ck-txt black text-lowercase">On-Site</label>
        </div>
        <h5 className=" mt-30">Phone Number</h5>

        {map(communityInfo?.phone_numbers, (item, index) => {
          return (
            <div key={`phone_update${index}`}>
              <div className={"half-fitem fitem"}>
                <div className="half-fitem fitem">
                  <input
                    type="text"
                    name={"phone"}
                    value={item?.phone || ''}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onCommunityInfoChanged(e, 'phone_numbers', index)}
                    className="form--control"
                    placeholder="Phone Number"
                    max={10}
                    maxLength={10}
                  />
                </div>
                <div className={"half-fitem fitem flex ai-center"}>
                  <Select
                    defaultValue={"home_phone"}
                    showArrow
                    name={'type'}
                    virtual={false}
                    style={{ width: '100%' }}
                    value={item?.type}
                    onChange={(e) => this.onCommunityInfoChanged({target: {name: 'type', value: e}}, 'phone_numbers', index)}
                  >
                    <Option value="home_phone">Home</Option>
                    <Option value="mobile">Mobile</Option>
                  </Select>
                  {index === 0 ? 
                    <a href="/#" onClick={(e) => {e.preventDefault(); this.onCommunityInfoChanged({}, 'add_more'); }}>
                      <img className="icoimg" src={plus_icon} alt="" />
                    </a> :
                    <a href="/#" onClick={(e) => { e.preventDefault(); this.onCommunityInfoChanged({}, 'remove_phone', index); }}>
                      <img className="icoimg" src={cross_icon} alt="" />
                    </a>}
                </div>                
              </div>
              {item?.type === 'mobile' ? <div className="fitem-check">
                <input
                  type="checkbox" name="can_send_sms"
                  className="fitem-ck-input"
                  checked={item?.can_send_sms}
                  id={`sendSMS${index}`}
                  onChange={(e) => this.onCommunityInfoChanged({target: {name: 'can_send_sms', value: e.target.checked}}, 'phone_numbers', index)}
                />
                <label htmlFor={`sendSMS${index}`} className="fitem-ck-txt">
                  Accept text messages at this number
                </label>
              </div> : ''}
            </div>
          )
        })}

        {/* Emails */}
        <h5 className=" mt-30">Email Addresses</h5>
        {
          communityInfo?.emails || communityInfo?.emails?.length > 0 ?
          map(orderBy(communityInfo?.emails, 'primary', 'desc'), (item, index) =>
            <div className={`fitem-check ${item?.primary ? '' : 'mt-10'}`} key={`communityEmail${index}`}>
              { item.primary ? 
                <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id={`communityEmail${index}`}
                  name={`communityEmail${index}`}
                  checked={item?.primary}
                  readOnly
                  // onChange={() => this.onChangePrimary('community', item.email)}
                /> : null
              }
              <label htmlFor={`communityEmail${index}`} className="fitem-ck-txt black text-lowercase">
                {`${item?.email?.toLowerCase()} ${item?.primary ? '(Primary)' : ''}`}
              </label>
              {
                !item?.primary ? 
                  <a
                    className="red float-right" 
                    href={'/#'}
                    onClick={(e) => {e.preventDefault(); this.onCommunityInfoChanged({}, 'remove_email', item); }}
                  >
                    Remove
                  </a>
                  : ''
              }
            </div>
          ) : null
        }
        <div className="fitem fitem-rinner mt-10">
          <input
            name="email"
            type="text"
            placeholder={"Add New Email Address"}
            value={communityInfo?.email}
            onChange={(e) => this.onCommunityInfoChanged(e, '')}
          />
          <button
            className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(communityInfo?.email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(communityInfo?.email)}
            onClick={() => this.onCommunityInfoChanged({}, 'emails')}><PlusOutlined /></button>
        </div>
        <div className="fitem">
          <h4>Notes</h4>
          <textarea
            id={"notes"}
            rows="4"
            name="notes"
            type="text"
            placeholder={"Please add any additional notes such as maintenance, assistant manager, etc."}
            value={communityInfo?.notes}
            onChange={(e) => this.onCommunityInfoChanged(e)} />
        </div>
        <div className="card-body">
          {
            communityInfo?.permissions?.length > 0 &&
            <div className="fitem-check text-right">
              <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Email</b></label>
              <label htmlFor="checkbox" className="fitem-ck-txt text-right" style={{marginLeft: "20px"}}><b>Text</b></label>
            </div>
          }
          {
            map(communityInfo?.permissions, (item, index) => {
              return (
                <div className={"flex ai-center mb-10"} key={`notification${index}`}>
                  <label><b>{item?.type_display}</b></label>
                  <div className="inline-check-list rcheck flex sm-checks gcheck">
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionCommunityEmail${index}`}
                        name={`email`}
                        checked={item?.email}
                        onChange={(e) => this.onCommunityInfoChanged(e, 'permission', '', item?.name)}
                      />
                      <label htmlFor={`permissionCommunityEmail${index}`} className="fitem-ck-txt"/>
                    </div>
                    <div className="fitem-check" style={{marginLeft: "22px", marginRight: "5px"}}>
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionCommunityText${index}`}
                        name={`text`}
                        checked={item?.text}
                        onChange={(e) => this.onCommunityInfoChanged(e, 'permission', '', item?.name)}
                      />
                      <label htmlFor={`permissionCommunityText${index}`} className="fitem-ck-txt"/>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  renderBillingInfo = () => {
    const {
      billingInfo,
      address,
      is_email_invoice,
      is_address_manually,
      is_print_and_mail_invoices,
    } = this.state;

    return (
      <div className="flex-1">
        <div className="fitem">
          <label>Billing Name</label>
          <input
            type="text"
            name={"billing_name"}
            value={billingInfo?.name || ''}
            onChange={(e) => this.onBillingInfoChanged(e, 'billing_name')}
            className="form--control"
            placeholder="Billing Name"
          />
        </div>

        <h5 className=" mt-30">Phone Number</h5>
        {map(billingInfo?.phone_numbers, (item, index) => {
          return (
            <div key={`phone_update${index}`}>
              <div className={"half-fitem fitem"}>
                <div className="half-fitem fitem">
                  <input
                    type="text"
                    name={"phone"}
                    value={item?.phone || ''}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onBillingInfoChanged(e, 'phone_numbers', index)}
                    className="form--control"
                    placeholder="Phone Number"
                    max={10}
                    maxLength={10}
                  />
                </div>
                <div className={"half-fitem fitem flex ai-center"}>
                  <Select
                    defaultValue={"home_phone"}
                    showArrow
                    name={'type'}
                    virtual={false}
                    style={{ width: '100%' }}
                    value={item?.type}
                    onChange={(e) => this.onBillingInfoChanged({target: {name: 'type', value: e}}, 'phone_numbers', index)}
                  >
                    <Option value="home_phone">Home</Option>
                    <Option value="mobile">Mobile</Option>
                  </Select>
                  {index === 0 ? <a href="/#" onClick={(e) => {e.preventDefault(); this.onBillingInfoChanged({}, 'add_more'); }}><img className="icoimg" src={plus_icon} alt="" /></a> :
                    <a href="/#" onClick={(e) => { e.preventDefault(); this.onBillingInfoChanged({}, 'remove_phone', index); }}><img className="icoimg" src={cross_icon} alt="" /></a>}
                </div>                
              </div>
              {item?.type === 'mobile' ? <div className="fitem-check">
                <input
                  type="checkbox" name="can_send_sms"
                  className="fitem-ck-input"
                  checked={item?.can_send_sms}
                  id={`sendSMS${index}`}
                  onChange={(e) => this.onBillingInfoChanged({target: {name: 'can_send_sms', value: e.target.checked}}, 'phone_numbers', index)}
                />
                <label htmlFor={`sendSMS${index}`} className="fitem-ck-txt">
                  Accept text messages at this number
                </label>
              </div> : ''}
            </div>
          )
        })}

        {/* Emails */}
        <h5 className=" mt-30">Email Addresses </h5>
        {
          billingInfo?.emails || billingInfo?.emails?.length > 0 ?
            map(orderBy(billingInfo?.emails?.filter(obj =>  obj.email), 'primary', 'desc'), (item, index) =>
              <div className="fitem-check" key={`billingEmail${index}`}>
                { item.primary ? <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id={`billingEmail${index}`}
                  name={`billingEmail${index}`}
                  checked={item?.primary}
                  readOnly
                  // onChange={() => this.onChangePrimary('billing', item.email)}
                /> : null }
                <label htmlFor={`billingEmail${index}`} className="fitem-ck-txt black text-lowercase">
                  {`${item?.email?.toLowerCase()} ${item?.primary ? '(Primary)' : ''}`}
                </label>
                {
                  !item?.primary ? 
                    <a
                      className="red float-right"
                      href={'/#'}
                      onClick={(e) => {
                        e.preventDefault();
                        this.onBillingInfoChanged({}, 'remove_email', index, '', item.email)
                      }}
                    >
                      Remove</a> : ''
                }
              </div>
            ) :
          null
        }
        { is_print_and_mail_invoices &&
          <div className="fitem">
            <h5 htmlFor="address" className=" mt-10">Invoice Address</h5>
            <div className="google_search_place">
              <Script
                url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
              />
              <input
                autoComplete="off"
                type="text"
                ref="address"
                placeholder={"Search for Invoice Address"}
                name="google_address"
                id="google_address"
                onChange={(e) => {
                  if (!e.target.value) {
                    this.setState({
                      address: { address: '', state: '', city: '', zip_code: '' }
                    })
                  }
                }}
                disabled={is_address_manually}
              />
              <b>or <a href="/" onClick={(e) => {
                e.preventDefault();
                this.setState({
                  is_address_manually: true,
                  address: { address: '', state: '', city: '', zip_code: '' },
                }, () => {
                  if (this.refs['address']) {
                    this.refs['address'].value = '';
                  } })
              }}><u>enter address manually</u></a></b>
            </div>
            {
              is_address_manually &&
              <div className="manually_address">
                <a href="/#" onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    is_address_manually: false,
                    address: { address: '', state: '', city: '', zip_code: '' },
                  })
                }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
                <br />

                <div className="form-group mb-20">
                  <div className="fitem">
                    <input
                      type="text"
                      placeholder="Address"
                      name="address"
                      value={address?.address}
                      onChange={(e) => this.onAddressChange(e)}
                    />
                  </div>
                  <div className="half-fitem fitem">
                    <div className="half-fitem fitem">
                      <input
                        type="text"
                        placeholder="City"
                        name="city"
                        value={address?.city}
                        onChange={(e) => this.onAddressChange(e)}
                      />
                    </div>
                    <div className="half-fitem fitem">
                      <Select
                        showArrow={true}
                        name="state"
                        placeholder="State"
                        onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                        value={address?.state || undefined}
                        virtual={false}
                      >
                        {this.renderAllState()}
                      </Select>
                    </div>
                    <div className="half-fitem fitem">
                      <input
                        type="text"
                        className='form--control'
                        placeholder="ZIP Code"
                        name="zip_code"
                        maxLength={5}
                        minLength={5}
                        onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                        value={address?.zip_code || ''}
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        <div className="fitem-check mt-10">
          <input
            type="checkbox"
            className="fitem-ck-input"
            id={`printInvoice`}
            name={`is_print_and_mail_invoices`}
            checked={is_print_and_mail_invoices}
            onChange={(e) => this.onPrintInvoiceChange(e)}
          />
          <label htmlFor={`printInvoice`} className="fitem-ck-txt">Print and Mail Invoice</label>
        </div>
        <div className="fitem-check mt-10">
          <input
            type="checkbox"
            className="fitem-ck-input"
            id={`emailInvoice`}
            name={`is_email_invoice`}
            checked={is_email_invoice}
            onChange={(e) => this.onEmailInvoiceChange(e)}
          />
          <label htmlFor={`emailInvoice`} className="fitem-ck-txt">Email invoices</label>
        </div>

        <div className="fitem fitem-rinner mt-10">
          <input
            name="email"
            type="text"
            placeholder={"Add New Email Address"}
            value={billingInfo?.email}
            onChange={(e) => this.onBillingInfoChanged(e, '')} />
          <button
            className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(billingInfo?.email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(billingInfo?.email)}
            onClick={() => this.onBillingInfoChanged({}, 'emails')}><PlusOutlined /></button>
        </div>
        <div className="card-body">
          {
            billingInfo?.permissions?.length > 0 &&
            <div className="fitem-check text-right">
              <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Email</b></label>
              <label htmlFor="checkbox" className="fitem-ck-txt text-right" style={{marginLeft: "22px"}}><b>Text</b></label>
            </div>
          }
          {
            map(billingInfo?.permissions, (item, index) => {
              return (
                <div className={"flex ai-center mb-10"} key={`notification${index}`}>
                  <label><b>{item?.type_display}</b></label>
                  <div className="inline-check-list rcheck flex sm-checks gcheck">
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionBillingEmail${index}`}
                        name={`email`}
                        checked={item?.email}
                        onChange={(e) => this.onBillingInfoChanged(e, 'permission', '', item?.name)}
                      />
                      <label htmlFor={`permissionBillingEmail${index}`} className="fitem-ck-txt"/>
                    </div>
                    <div className="fitem-check" style={{marginLeft: "22px", marginRight: "5px"}}>
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionBillingText${index}`}
                        name={`text`}
                        checked={item?.text}
                        onChange={(e) => this.onBillingInfoChanged(e, 'permission', '', item?.name)}
                      />
                      <label htmlFor={`permissionBillingText${index}`} className="fitem-ck-txt"/>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  renderCompanyInfo = () => {
    const {companyInfo} = this.state;
    return (
      <div className="flex-1">
        <div className="fitem">
          <label>Management Company</label>
          <input
            type="text"
            name={"company_name"}
            value={companyInfo?.name || ''}
            onChange={(e) => this.onCompanyInfoChanged(e, 'company_name')}
            className="form--control"
            placeholder="Billing   Name"
          />
        </div>
        <div className="fitem">
          <label>Point of Contact</label>
          <input
            type="text"
            name={"pointOfContact"}
            value={companyInfo?.pointOfContact}
            onChange={(e) => this.onCompanyInfoChanged(e)}
            className="form--control"
            placeholder="Point of Contact"
          />
        </div>

        <h5 className=" mt-30">Phone Number</h5>
        {map(companyInfo?.phone_numbers, (item, index) => {
          return (
            <div key={`phone_update${index}`}>
              <div className={"half-fitem fitem"}>
                <div className="half-fitem fitem">
                  <input
                    type="text"
                    name={"phone"}
                    value={item?.phone || ''}
                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onCompanyInfoChanged(e, 'phone_numbers', index)}
                    className="form--control"
                    placeholder="Phone Number"
                    max={10}
                    maxLength={10}
                  />
                </div>
                <div className={"half-fitem fitem ai-center flex"}>
                  <Select
                    defaultValue={"home_phone"}
                    showArrow
                    name={'type'}
                    virtual={false}
                    style={{ width: '100%' }}
                    value={item?.type}
                    onChange={(e) => this.onCompanyInfoChanged({target: {name: 'type', value: e}}, 'phone_numbers', index)}
                  >
                    <Option value="home_phone">Home</Option>
                    <Option value="mobile">Mobile</Option>
                  </Select>
                  {index === 0 ? <a href="/#" onClick={(e) => {e.preventDefault(); this.onCompanyInfoChanged({}, 'add_more'); }}><img src={plus_icon} alt="" /></a> :
                    <a href="/#" onClick={(e) => { e.preventDefault(); this.onCompanyInfoChanged({}, 'remove_phone', index); }}><img src={cross_icon} alt="" /></a>}
                </div>
            
              </div>
              {item?.type === 'mobile' ? <div className="fitem-check">
                <input
                  type="checkbox" name="can_send_sms"
                  className="fitem-ck-input"
                  checked={item?.can_send_sms}
                  id={`sendSMS${index}`}
                  onChange={(e) => this.onCompanyInfoChanged({target: {name: 'can_send_sms', value: e.target.checked}}, 'phone_numbers', index)}
                />
                <label htmlFor={`sendSMS${index}`} className="fitem-ck-txt">
                  Accept text messages at this number
                </label>
              </div> : ''}
            </div>
          )
        })}

        {/* Emails */}
        <h5 className=" mt-30">Email Addresses</h5>
        {
          map(orderBy(companyInfo?.emails.filter(obj =>  obj.email), 'primary', 'desc'), (item, index) =>
            <div className="fitem-check" key={`companyEmail${index}`}>
              { item.primary ? <input
                type="checkbox"
                className="fitem-ck-input"
                id={`companyEmail${index}`}
                name={`companyEmail${index}`}
                checked={item?.primary}
                readOnly
                // onChange={() => this.onChangePrimary('company', item.email)}
              /> : null }
              <label htmlFor={`companyEmail${index}`} className="fitem-ck-txt black text-lowercase">
                {`${item?.email?.toLowerCase()} ${item?.primary ? '(Primary)' : ''}`}
              </label>
              {
                !item?.primary ? 
                  <a
                    className="red float-right"
                    href={'/#'}
                    onClick={(e) => {e.preventDefault(); this.onCompanyInfoChanged({}, 'remove_email', index, '', item.email)}}
                  >Remove</a> : ''
              }
            </div>
          )
        }
        <div className="fitem fitem-rinner mt-10">
          <input
            name="email"
            type="text"
            placeholder={"Add New Email Address"}
            value={companyInfo?.email}
            onChange={(e) => this.onCompanyInfoChanged(e, '')} />
          <button
            className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(companyInfo?.email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(companyInfo?.email)}
            onClick={() => this.onCompanyInfoChanged({}, 'emails')}><PlusOutlined /></button>
        </div>
        <div className="card-body">
          {
            companyInfo?.permissions?.length > 0 &&
            <div className="fitem-check text-right">
              <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Email</b></label>
              <label htmlFor="checkbox" className="fitem-ck-txt text-right" style={{marginLeft: "22px"}}><b>Text</b></label>
            </div>
          }
          {
            map(companyInfo?.permissions, (item, index) => {
              return (
                <div className={"flex ai-center mb-10"} key={`notification${index}`}>
                  <label><b>{item?.type_display}</b></label>
                  <div className="inline-check-list rcheck flex sm-checks gcheck">
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionCompanyEmail${index}`}
                        name={`email`}
                        checked={item?.email}
                        onChange={(e) => this.onCompanyInfoChanged(e, 'permission', '', item?.name)}
                      />
                      <label htmlFor={`permissionCompanyEmail${index}`} className="fitem-ck-txt"/>
                    </div>
                    <div className="fitem-check" style={{marginLeft: "22px", marginRight: "5px"}}>
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionCompanyText${index}`}
                        name={`text`}
                        checked={item?.text}
                        onChange={(e) => this.onCompanyInfoChanged(e, 'permission', '', item?.name)}
                      />
                      <label htmlFor={`permissionCompanyText${index}`} className="fitem-ck-txt"/>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  render() {
    const {openDrawer} = this.props;
    const {loader,is_btn_active} = this.state;
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={() => this.onCancel()}
        visible={openDrawer}
        key={'right'}
        width={'1170'}
        className="drawer-wrapper"
      >
        <div className="rdrawer updateco filter_drawer_wrapper">
          {loader && <Loader />}
          <div className="card-row flex-column">
            <div className="card-body"> 
              <div className="card-full pb-0 flex">               
                <h4 className="mb-0">Update Contact Details</h4>
                <CloseOutlined onClick={() => this.onCancel()}/>            
              </div>               
            </div>
            <div className="card-body flex">              
              <div className="card-full"> 
                <div className="form-group">                
                  {this.renderCommunityManagerInfo()}
                </div>
              </div>
              <div className="card-full">
                <div className="form-group">
                  {this.renderBillingInfo()}
                </div>
              </div>
              <div className="card-full"> 
                <div className="form-group">
                  {this.renderCompanyInfo()}  
                </div>            
              </div>
            </div> 
          </div>            
                   
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={() => this.onCancel()}>Cancel</button>
            <button
              // type="submit"
              disabled={!is_btn_active}
              className={`btn btn-warning`}
              onClick={() => this.onUpdateClick()}>
              Update
            </button>
          </div>
        </div>
      </Drawer>
    )
  }
}

export default UpdateContact;